import {
  AuthPayload,
  authTypes,
  ChangePasswordPayload,
  ExchangeTokenPayLoad,
  PermissionPayload,
  SignInPayload,
} from './types';

const signIn = (payload: SignInPayload, onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: authTypes.SIGN_IN,
  payload,
  onSuccess,
  onError,
});

const signOut = (onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: authTypes.SIGN_OUT,
  onSuccess,
  onError,
});

const setAuth = (payload: AuthPayload) => ({
  type: authTypes.SET_AUTH,
  payload,
});

const getPermission = (onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: authTypes.GET_PERMISSION,
  onSuccess,
  onError,
});

const setPermissions = (payload: PermissionPayload) => ({
  type: authTypes.SET_PERMISSIONS,
  payload,
});

const exchangeToken = (
  payload: ExchangeTokenPayLoad,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: authTypes.EXCHANGE_TOKEN,
  payload,
  onSuccess,
  onError,
});

const changePassword = (
  payload: ChangePasswordPayload,
  onSuccess: (...args: any[]) => void,
  onError: (...args: any[]) => void,
) => ({
  type: authTypes.CHANGE_PASSWORD,
  payload,
  onSuccess,
  onError,
});

export { signIn, signOut, setAuth, getPermission, setPermissions, exchangeToken, changePassword };
